@if ($items().length || $pending()) {
  <div class="board-kanban-body" [class.is-pending]="$pending()" [attr.role]="$pending() ? 'status' : null" [attr.aria-busy]="$pending() ? 'true' : null">
    <w-kanban class="board-kanban" [class.display-card]="$isCardMode()" [swimlanes]="$swimlanes()" [selectedItem]="$selectedItem()" [editorType]="KanbanEditorType.Internal" [showHeader]="$showSwimlaneHeaders()" [itemKey]="$itemKey()" [emptyMessage]="$isCardMode() ? 'No cards' : 'No items'" (itemSelected)="onItemSelected($event)" (itemDblClicked)="onItemDblClicked($event)">
      <ng-template swimlaneHeaderTemplate let-item="item">
        <!-- Gesture on the header BODY, never on the chevron: collapse stays the chevron's and the
             tap opens the lane's parent, so the two can never take each other's click. -->
        <div class="swimlane-header-tap" wbPointerGestures (tap)="onSwimlaneHeaderTap(item)">
          <!-- Manifest escape hatch first; every other entity gets the metadata-driven header. -->
          @if ($rowHeaderComponent(); as rowHeader) {
            <ng-container *ngComponentOutlet="rowHeader; inputs: rowHeaderInputs(item)" />
          } @else {
            <kanban-swimlane-header [row]="getSwimlaneRow(item)" [laneName]="getSwimlaneTitle(item)" [countLabel]="getSwimlaneCountLabel(item)" [count]="getSwimlaneItemCount(item)" [view]="$view()" [metadata]="$metadata()" [rowField]="$effectiveSwimlanePath()" />
          }
        </div>
      </ng-template>

      <ng-template columnTemplate let-column let-count="count">
        <div class="column-header">
          <span class="dot" [style.background]="getColumnColor(column)"></span>
          <span class="label">{{ column.name }}</span>
          <!-- The chip stays a bare number so a narrow column header still fits; the noun rides the
               tooltip, where it says what the board is actually counting. -->
          <span class="count" [title]="getColumnCountLabel(count)">{{ getColumnCountText(count) }}</span>
        </div>
      </ng-template>

      <ng-template itemTemplate let-item="item">
        <entity-card [item]="item" [metadata]="$metadata()" [card]="$cardConfig()" [selected]="isSelected(item)" />
      </ng-template>
    </w-kanban>
  </div>
} @else {
  <board-empty class="is-fill" />
}
